import React from "react";
import { Container, Row, Col, Card, CardHeader, CardBody } from "shards-react";
import ClientsIndexComponent from "../../components/Clients";

import PageTitle from "../../components/common/PageTitle";



const ClientsView = () => (
  <Container fluid className="main-content-container px-4 backend">

    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="Klanten" subtitle="Dirix B.V." className="text-sm-left" />
    </Row>


    <Row>
      <Col lg="12">
          <ClientsIndexComponent />
       
      </Col>
    </Row>
  </Container>
);

export default ClientsView;
